import { IterableElement } from 'type-fest'

import { Ticker } from '../ticker'

export const BASE_TOKEN_TICKERS = [Ticker.USDC]

export type BaseTokenTicker = IterableElement<typeof BASE_TOKEN_TICKERS>
